// extracted by mini-css-extract-plugin
export default {"modal":"ovdata_modal__3Uzd6"};